import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import IconButton from "@material-ui/core/IconButton";
import UserImpersonations from './Impersonations';
import { useCognitoProvider } from '../../providers/CognitoContext';
import { actions } from '../../actions/cognito';
import UserDividerItem from './Divider';
import UserDisabledItem from './Disabled';
import { useHistory } from 'react-router-dom';
import { useMenuProvider } from '../../providers/MenuContext';
import { redirectAfterImpersonationActions } from '../../utils/functions';

const useStyles = makeStyles((theme) => ({
    menuIcon: {
        minWidth: 0,
        marginLeft: theme.spacing(1),
        color: '#4f6b5c',
    },
    menuItem: {
        minHeight: 0,
    },
    button: {
        color: '#4f6b5c',
        borderRadius: 8,
        padding: 8,
        '&:hover': {
            backgroundColor: 'rgba(0, 124, 90, 0.07)',
            color: '#007C5A',
        },
    },
    userLabel: {
        fontSize: '0.8rem',
        fontWeight: 600,
        color: '#1a2e22',
    },
    headerLabel: {
        fontSize: '0.75rem',
        fontWeight: 700,
        color: '#4f6b5c',
        textTransform: 'uppercase',
        letterSpacing: '0.06em',
    },
    logoutIcon: {
        color: '#e53935',
    },
    logoutText: {
        color: '#e53935',
        fontWeight: 600,
    },
}));

export default function User() {

    const classes = useStyles();
    const [menuOpen, setMenuOpen] = useState(null);
    const { state, dispatch } = useCognitoProvider();
    const history = useHistory();
    const { setCurrentRoute } = useMenuProvider();

    const openMenu = (event) => setMenuOpen(event.currentTarget);
    const closeMenu = () => setMenuOpen(null);

    const logOut = () => {
        if (state.impersonated) {
            dispatch({ type: actions.LOG_OUT_IMPERSONATE });
            redirectAfterImpersonationActions(history, setCurrentRoute);
            closeMenu();
        } else {
            dispatch({ type: actions.LOG_OUT });
        }
    };

    return (
        <>
            <IconButton className={classes.button} onClick={openMenu} aria-label="Menú de usuario">
                <AccountCircleIcon />
            </IconButton>
            <Menu
                anchorEl={menuOpen}
                keepMounted
                open={Boolean(menuOpen)}
                onClose={closeMenu}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                getContentAnchorEl={null}
            >
                <UserDisabledItem>
                    <Typography className={classes.headerLabel} noWrap>Usuario conectado</Typography>
                </UserDisabledItem>
                <UserDividerItem />
                <UserDisabledItem>
                    <Typography className={classes.userLabel} noWrap>{state.userName}</Typography>
                </UserDisabledItem>
                <UserImpersonations handleClose={closeMenu} />
                <UserDividerItem />
                <MenuItem className={classes.menuItem} onClick={logOut}>
                    <Typography className={classes.logoutText} variant="inherit" noWrap>Desconectar</Typography>
                    <ListItemIcon className={`${classes.menuIcon} ${classes.logoutIcon}`}>
                        <ExitToAppIcon fontSize="small" />
                    </ListItemIcon>
                </MenuItem>
            </Menu>
        </>
    );
}
